import { Injectable } from '@angular/core';
import { Observable, of, delay, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private apiUrl = environment.apiUrl;
    private headers!: HttpHeaders;

    constructor(private http: HttpClient) {}

    // Obtener los datos de las órdenes emitidas hoy
    getDatosStatsWidgets(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}dashboards/stats_widgets_usr`);
    }

    // Obtener los datos de las órdenes emitidas hoy
    getDatosGraphBranches(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}dashboards/graph_branches`);
    }
}
